import { createContext, useContext, useReducer } from "react";
import { initialState, productDeliveryReducer } from "../reducer/productDeliveryReducer";

const ProductDeliveryStateContext = createContext();
const ProductDeliveryDispatchContext = createContext();

export const ProductDeliveryProvider = ({ children }) => {
  const [state, dispatch] = useReducer(productDeliveryReducer, initialState);

  return (
    <ProductDeliveryStateContext.Provider value={state}>
      <ProductDeliveryDispatchContext.Provider value={dispatch}>
        {children}
      </ProductDeliveryDispatchContext.Provider>
    </ProductDeliveryStateContext.Provider>
  )
}

export const useProductDeliveryState = () => {
  const context = useContext(ProductDeliveryStateContext);

  if (!context) throw Error('useProductDeliveryState는 ProductDeliveryProvider 내에서 사용해야 합니다.');
  return context;
}

export const useProductDeliveryDispatch = () => {
  const context = useContext(ProductDeliveryDispatchContext);

  if (!context) throw Error('useProductDeliveryDispatch는 ProductDeliveryProvider 내에서 사용해야 합니다.');
  return context;
}